"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateRange = void 0;
var dateRange_1 = require("./dateRange");
Object.defineProperty(exports, "DateRange", { enumerable: true, get: function () { return __importDefault(dateRange_1).default; } });
//# sourceMappingURL=index.js.map